// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "@rescript/react/src/React.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.jsx";

let make = React.lazy_(() => new Promise((param, param$1) => {}));

let NeverResolvingLazyComponent = {
  make: make
};

function Redirect(props) {
  RescriptReactRouter.replace(props.to);
  return <NeverResolvingLazyComponent.make />;
}

let make$1 = Redirect;

export {
  NeverResolvingLazyComponent,
  make$1 as make,
}
/* make Not a pure module */
